export const MAX_PROGRAM_BYTES = 10 * 1024 * 1024;
export function programFileError(file) {
  if (!file || !/\.pdf$/i.test(file.name) || (file.type && file.type !== "application/pdf")) return "Choose a PDF file.";
  if (!file.size) return "This file is empty. Choose a complete PDF.";
  if (file.size > MAX_PROGRAM_BYTES) return "The PDF must be 10 MB or smaller.";
  if (file.name.length > 180) return "Shorten the file name to 180 characters or fewer.";
  return "";
}
export function programSize(bytes) {
  return bytes >= 1024 * 1024 ? `${(bytes / (1024 * 1024)).toFixed(1)} MB` : `${Math.max(1, Math.round(bytes / 1024))} KB`;
}
export function uploadProgramFile(upload, file, onProgress) {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open("PUT", upload.uploadUrl);
    xhr.timeout = 120000;
    Object.entries(upload.headers).forEach(([name, value]) => xhr.setRequestHeader(name, value));
    xhr.upload.onprogress = event => { if (event.lengthComputable) onProgress(Math.round(event.loaded / event.total * 100)); };
    xhr.onload = () => xhr.status >= 200 && xhr.status < 300 ? resolve() : reject(new Error("Upload failed. Your current program has not changed. Try again."));
    xhr.onerror = () => reject(new Error("Connection lost during upload. Check your connection and try again."));
    xhr.ontimeout = () => reject(new Error("The upload timed out. Try again on a stable connection."));
    xhr.send(file);
  });
}
